import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function MoreHorizontalIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M7.99998 8.66671C8.36817 8.66671 8.66665 8.36823 8.66665 8.00004C8.66665 7.63185 8.36817 7.33337 7.99998 7.33337C7.63179 7.33337 7.33331 7.63185 7.33331 8.00004C7.33331 8.36823 7.63179 8.66671 7.99998 8.66671Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 8.66671C13.0349 8.66671 13.3333 8.36823 13.3333 8.00004C13.3333 7.63185 13.0349 7.33337 12.6667 7.33337C12.2985 7.33337 12 7.63185 12 8.00004C12 8.36823 12.2985 8.66671 12.6667 8.66671Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33335 8.66671C3.70154 8.66671 4.00002 8.36823 4.00002 8.00004C4.00002 7.63185 3.70154 7.33337 3.33335 7.33337C2.96516 7.33337 2.66669 7.63185 2.66669 8.00004C2.66669 8.36823 2.96516 8.66671 3.33335 8.66671Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default MoreHorizontalIcon;
